export default {
  draft: '草稿',
  submitted: '待接单',
  deal: '待派车',
  toBeDeliver: '待出库',
  delivering: '出库中',
  delivered: '已出库',
  dispatched: '已派车',
  started: '运输中',
  signed: '已签收',
  toBeStore: '待入库',
  storing: '入库中',
  stored: '已入库',
  finished: '已完成',
  canceled: '已取消',
  rejected: '已拒收',
  expStatus: '异常',
  partSigned: '部分签收',
};

export const CHANGETYPE = {
  CREATE: '新增替换站点信息',
  UPDATE: '更新原站点信息'
}

export const FLOWSTATUS = {
  FAIL: '提交失败',
  TO_BE_APPROVAL: '待审核',
  REJECTED: '审核拒绝',
  APPROVAL: '审核通过',
  APPROVAL_TERMINATION: '审核终止'
}